import { takeLatest, put, select } from 'redux-saga/effects';
import get from 'lodash/get';

import { getRealtimeData } from '@api/metricContainer';
import { autoRequest } from '@api/createRequestStore';

import * as actions from './actions';
import * as types from './types';
import * as selectors from './selectors';
import * as baseTypes from '../base/types';
import { applyDrilldown } from '../base/actions';
import { getThresholdData } from '../threshold/actions';
import { isThresholdDisabledSelector } from '../threshold/selectors';
import { checkIfSampledCluster } from '@components/common/SampledDataWarning';
import { handleServerError } from '@utils/errors/serverError';
import { DATE_SHORTCUTS, isAppModule } from '@utils/constants';
import calcShortcutInterval from '@utils/calcShortcutInterval';

function* initRequest() {
  yield put(actions.init());
}

function* fetching() {
  const payloads = yield select(selectors.payloadSelector);

  if (!payloads || payloads.length <= 1) {
    return;
  }
  if (isAppModule) {
    payloads.queries.forEach((query) => {
      const [start, end] = calcShortcutInterval(DATE_SHORTCUTS.last15Mins);
      query.interval = `${start.format()}/${end.format()}`;
    });
  }
  try {
    yield put(actions.fetching());
    yield autoRequest(getRealtimeData, types.SCOPE, payloads, (response) => {
      const annotations = get(response, [0, 'annotations'], []);
      checkIfSampledCluster(annotations);
    });

    // fetch threshold data if feature is enabled
    const isNocDisabled = yield select(isThresholdDisabledSelector);
    if (!isNocDisabled) {
      yield put(getThresholdData());
    }
  } catch (error) {
    handleServerError(error);
  }
}

function* drilldown(action) {
  const { metric, row, history } = action.params;
  const rules = get(row, 'filter.rule', []);

  // base saga will trigger the apply action
  yield put(applyDrilldown({ metric, rules, history }));
}

function* watchInitRequest() {
  yield takeLatest([types.INIT], initRequest);
}

function* watchFetching() {
  yield takeLatest(
    [
      types.FETCH_DATA,
      baseTypes.SET_FILTERS_METRICS,
      baseTypes.UPDATE_SAVED_FILTERS_SELECTED_NOC_FILTERS,
      baseTypes.APPLY_FILTERS_SELECTED_NOC_FILTERS,
    ],
    fetching,
  );
}

function* watchDrilldown() {
  yield takeLatest([types.DRILLDOWN], drilldown);
}

export default [watchInitRequest, watchFetching, watchDrilldown];
